// keep in sync with media-queries.module.scss
export const PHONES_ONLY_BREAKPOINT = 480;
